export default "__VITE_ASSET__03f32ebc__"